var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tickcross"},[(_vm.value)?_c('font-awesome-icon',{staticClass:"tick",attrs:{"icon":['far', 'check-circle']}}):_vm._e(),(!_vm.value)?_c('font-awesome-icon',{staticClass:"cross",attrs:{"icon":['far', 'times-circle']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }